import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link } from 'react-router-dom'; 
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';

import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";


let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";

if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: "#",
    field: "sr_no",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "#",
    },
  },
  {
    label: "Item Name",
    field: "item_name",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Item Name",
    },
  },
  {
    label: "Sale Quantity",
    field: "sale_qty",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Sale Quantity",
    },
  },
  {
    label: "Sale Amount",
    field: "sale_amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Sale Amount",
    },
  },
  {
    label: "Purchase Quantity",
    field: "purchase_qty",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Purchase Quantity",
    },
  },
  {
    label: "Purchase Amount",
    field: "purchase_amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Purchase Amount",
    },
  },
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;
export default class dayBookReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      activeTransactionKey: "ALL",
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,
      startDate : moment().startOf('month').format('YYYY-MM-DD'),
      endDate : moment().endOf('month').format('YYYY-MM-DD'),
      dateLabel: "",
      partyArrayList: [],
      selectedPartyId: "0",
      selectedPartyName: "All Parties",
      showPartyDropdown: false,
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getPartyList();
    this.getSaleListData(this.state.activeTransactionKey);
  }

  getPartyList() {
    let _url_GetData = global.userPartyList + "?company_id=" + this.state.company_id;
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success && responseJson.response) {
          this.setState({ partyArrayList: responseJson.response });
        }
      })
      .catch((error) => console.error("Party List Error: ", error));
  }
  getSaleListData(_type) {
    let _transArray = [];
    let _totalSaleAmt = 0;
    let _totalPurchaseAmt = 0;
    let _totalSaleQty = 0;
    let _totalPurchaseQty = 0;

    const requestData = JSON.stringify({
        company_id: this.state.company_id,
        type: _type,
        isDateFilter: true,
        start_date: this.state.startDate,
        end_date: this.state.endDate,
        party_id: this.state.selectedPartyId,
    });

    PostData(global.userItemTransactions, requestData, "POST")
        .then((result) => {
            let responseJson = result;
            if (!responseJson.success) {
                this.setState({
                    transactionArrayFilter: _transArray,
                    itemArray: _transArray,
                    isLoaded: true,
                    totalSaleAmount: _totalSaleAmt,
                    totalPurchaseAmount: _totalPurchaseAmt,
                    totalSaleQuantity: _totalSaleQty,
                    totalPurchaseQuantity: _totalPurchaseQty,
                });
            } else {
                if (responseJson.response) {
                    _transArray = responseJson.response;
                    _transArray.forEach((itm) => {
                        _totalSaleAmt += parseFloat(itm.total_sale_amount) || 0;
                        _totalSaleQty += parseFloat(itm.total_sale_quantity) || 0;
                        _totalPurchaseAmt += parseFloat(itm.total_purchase_amount) || 0;
                        _totalPurchaseQty += parseFloat(itm.total_purchase_quantity) || 0;
                    });
                }

                this.setState({
                    transactionArrayFilter: _transArray,
                    itemArray: _transArray,
                    isLoaded: true,
                    totalSaleAmount: _totalSaleAmt,
                    totalPurchaseAmount: _totalPurchaseAmt,
                    totalSaleQuantity: _totalSaleQty,
                    totalPurchaseQuantity: _totalPurchaseQty,
                });
            }
        })
        .catch((error) => this.setState({ error, isLoaded: false }));
  }

  loadTranscListing() {
    let dataList = [];
    let rows = [];

    if (this.state.isLoaded) {
        let _transDetails = this.state.transactionArrayFilter;

        if (_transDetails.length > 0) {
            _transDetails.forEach((value, index) => {
                let _actionExtra = (
                    <div className="btn-group" role="group">
                        <button type="button" id="btnGroupVerticalDrop3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="fa fa-ellipsis-v"></i>
                        </button>
                        <div className="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                            <a className="dropdown-item" href={global.webUrl + "business/download-pdf/?auth=" + value.item_id} target="_blank">Download PDF</a>
                            <a className="dropdown-item" href={global.webUrl + "business/download-pdf/?auth=" + value.item_id} target="_blank">Preview</a>
                            <a className="dropdown-item" href={global.webUrl + "business/download-pdf/?auth=" + value.item_id} target="_blank">Print</a>
                        </div>
                    </div>
                );

                rows.push({
                    srNo: index + 1,
                    item_name: value.item_name,
                    sale_quantity: value.total_sale_quantity,
                    sale_amount: numberFormat(value.total_sale_amount),
                    purchase_quantity: value.total_purchase_quantity,
                    purchase_amount: numberFormat(value.total_purchase_amount),
                });
            }); 
        }
    }

    if (rows.length > 0) {
        dataList = {
            columns: [
                { label: "Sr No", field: "srNo" },
                { label: "Item Name", field: "item_name" },
                { label: "Sale Qty", field: "sale_quantity" },
                { label: "Sale Amount", field: "sale_amount" },
                { label: "Purchase Qty", field: "purchase_quantity" },
                { label: "Purchase Amount", field: "purchase_amount" }
            ],
            rows: rows,
        };
    }
    return dataList;
  }


  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    }, () => this.getSaleListData());
  };

  handlePartyFilter = (partyId, partyName) => {
    this.setState({
      selectedPartyId: partyId,
      selectedPartyName: partyName,
      showPartyDropdown: false
    }, () => this.getSaleListData());
  };

  togglePartyDropdown = () => {
    this.setState({ showPartyDropdown: !this.state.showPartyDropdown });
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getSaleListData();
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }


  exportData = (event) =>{
    let _itemDetails = this.state.transactionArrayFilter;
    try {
      let totalAmount = 0;

      _itemDetails = _itemDetails.map((data) => {
        let newData = {
          'Sr No.': data.srNo,
          'Item Name': data.item_name,
          'Sale Qty': data.sale_quantity,
          'Sale Amount': numberFormat(data.sale_amount),
          'Purchase Qty': data.purchase_quantity,
          'Purchase Amount': numberFormat(data.purchase_amountt)
        }
          return newData;
      });


      _itemDetails.push({});
      var ws = XLSX.utils.json_to_sheet(_itemDetails);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"Item Report By Party");
      const wbout = XLSX.write(wb, {type:'array', bookType:"xlsx"});
      let length = 6;
      let uniqueNo = String(Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)));
      let fileName = 'export_item_report_by_party'+moment().format('YYYY-MM-DD')+'.xlsx';
      const data = new Blob([wbout], {type: "xlsx"});
      FileSaver.saveAs(data, fileName);

    } catch (err) {
      //alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
    }
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Item Report by Party</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-4">
                          <span>Date Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-7"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-4">
                          <span>Party : </span>
                          <div className="custom-dropdown">
                            <div className="custom-dropdown-btn" onClick={this.togglePartyDropdown}>
                              <span>{this.state.selectedPartyName}</span>
                              <span> ▼</span>
                            </div>
                            {this.state.showPartyDropdown && (
                              <div className="custom-dropdown-menu">
                                <div
                                  className={`custom-dropdown-item ${this.state.selectedPartyId === "0" ? "selected" : ""}`}
                                  onClick={() => this.handlePartyFilter("0", "All Parties")}
                                >
                                  All Parties
                                </div>
                                {this.state.partyArrayList.map((party) => (
                                  <div
                                    key={party.party_id}
                                    className={`custom-dropdown-item ${this.state.selectedPartyId === String(party.party_id) ? "selected" : ""}`}
                                    onClick={() => this.handlePartyFilter(String(party.party_id), party.party_name)}
                                  >
                                    {party.party_name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="row pb-20 pull-right">
                            <div className="text-right">
                              <div className="js-appear-enabled text-center">
                                <Link onClick={this.exportData} >
                                  <div className="text-info">
                                    <i className="fa fa-file-excel-o"></i>
                                  </div>
                                  <div className="font-size-sm text-muted">
                                    Excel Export
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Transactions</h2>
                    {/* <a href={global.webUrl+"business/add-sale/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                        <i className="fa fa-plus-circle"></i> Add Sale
                    </a> */}
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      entriesOptions={[25, 50, 100, 500]}
                      entries={25}
                      pagesAmount={4}
                      span
                      //pagingTop
                      searchTop
                      searchBottom={false}
                      barReverse
                      data={this.loadTranscListing()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
